var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7946 12.8206L40.4164 44.0706C35.7516 42.8206 30.8046 43.1449 26.3428 44.993C21.881 46.8411 18.1537 50.1099 15.739 54.2922C13.3243 58.4746 12.3572 63.3369 12.9875 68.125C13.6179 72.9131 15.8106 77.3594 19.2255 80.7743C22.6404 84.1892 27.0867 86.3819 31.8748 87.0123C36.6628 87.6426 41.5251 86.6754 45.7075 84.2607C49.8899 81.846 53.1587 78.1188 55.0068 73.657C56.8549 69.1952 57.1792 64.2482 55.9292 59.5834L61.5382 53.8462V43.5898H71.7946V33.3334H82.051L87.1792 28.2052V12.8206L71.7946 12.8206Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6919 74.3589C36.5862 74.3589 39.7432 71.2019 39.7432 67.3076C39.7432 63.4133 36.5862 60.2563 32.6919 60.2563C28.7976 60.2563 25.6406 63.4133 25.6406 67.3076C25.6406 71.2019 28.7976 74.3589 32.6919 74.3589Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey1);
export default __webpack_public_path__ + "static/media/Key 1.837b5761a6de424ab2c8a92f3a2be84a.svg";
export { ForwardRef as ReactComponent };